export const buildAiModelOptions = (models = [], currentModelId = "") => {
  const options = models
    .filter(model => model.status !== "retired" || model.modelId === currentModelId)
    .map(model => ({ ...model, unknown: false }));
  if (currentModelId && !options.some(model => model.modelId === currentModelId)) {
    options.push({
      modelId: currentModelId,
      displayName: currentModelId,
      provider: "unknown",
      purpose: "conversation",
      status: "unknown",
      availableForNewUse: false,
      recommended: false,
      capabilities: {},
      parameters: {},
      replacementModelId: null,
      unknown: true
    });
  }
  return options;
};

export const getRecommendedAiModelId = (models = []) =>
  models.find(model => model.recommended && model.availableForNewUse)?.modelId ||
  models.find(model => model.availableForNewUse)?.modelId ||
  "";

export const aiModelLabel = model => {
  const tags = [];
  if (model.recommended) tags.push("recomendado");
  if (model.status === "active" && !model.availableForNewUse) {
    tags.push("aguardando homologação");
  }
  if (model.status === "deprecated") tags.push("descontinuando");
  if (model.status === "retired") tags.push("retirado");
  if (model.unknown) tags.push("não reconhecido");
  return `${model.displayName || model.modelId}${tags.length ? ` — ${tags.join(", ")}` : ""}`;
};

export const aiModelStatusMessage = model => {
  if (!model || (model.status === "active" && model.availableForNewUse)) return "";
  const replacement = model.replacementModelId
    ? ` Modelo sugerido: ${model.replacementModelId}. A troca só ocorrerá se você a selecionar.`
    : "";
  if (model.unknown) {
    return `Este identificador não consta no catálogo. Ele será preservado enquanto o modelo não for alterado.${replacement}`;
  }
  if (model.status === "active" && !model.availableForNewUse) {
    return "Este modelo está cadastrado, mas ainda não foi homologado para novos usos.";
  }
  if (model.status === "retired") {
    return `Este modelo foi retirado e permanece apenas para compatibilidade da configuração existente.${replacement}`;
  }
  return `Este modelo está em descontinuação e permanece apenas para compatibilidade.${replacement}`;
};

export const supportsAiModelParameter = (model, parameter) =>
  model?.parameters?.[parameter]?.supported !== false &&
  Boolean(model?.parameters?.[parameter]);

export const getAiModelParameterConfig = (model, parameter) =>
  model?.parameters?.[parameter] || {};
